class Cookie {
  	/**
   	* Set a cookie that expires in a given number of days (default: 1 day)
   	* @param {string} name - Cookie name
   	* @param {string} value - Cookie value
   	* @param {number} [days=1] - Expiration time in days
   	*/
  	static set(name, value, days = 1) {
    	const now = new Date();
    	now.setTime(now.getTime() + days * 24 * 60 * 60 * 1000);
    	const expires = `expires=${now.toUTCString()}`;
    	document.cookie = `${name}=${encodeURIComponent(value)}; ${expires}; path=/; SameSite=Lax`;
  	}

  	/**
   	* Get a cookie by name
   	* @param {string} name - Cookie name
   	* @returns {string|null} Cookie value or null if not found
   	*/
  	static get(name) {
    	const cookies = document.cookie.split('; ');
    	for (const cookie of cookies) {
			const [key, value] = cookie.split('=');
			if (key === name) {
				return decodeURIComponent(value);
			}
    	}
    	return null;
  	}

  	/**
   	* Delete a cookie by name
   	* @param {string} name - Cookie name
   	*/
  	static delete(name) {
    	// Set expiry to the past to remove it
    	document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Lax`;
  	}
};

export default Cookie;